export default __webpack_public_path__ + "static/media/Standard22.672bdeac.png";